import { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATH } from 'routes';
import Button from 'components/UI/Button';
import Layout from 'components/Layout';
import AppShell from 'components/Layout/AppShell';

const ErrorLayout = (props) => {
  const {
    title = '',
    status = 500,
    error = null,
    literals,
    children = null,
  } = props;

  const [showDetails, setShowDetails] = useState(false);
  const navigate = useNavigate();

  const renderBoundaryError = () => {
    if (!error?.error && !error?.info) {
      return null;
    }
    return (
      <div className='boundary-error-message mt-12' style={{ display: 'none' }}>
        <b onClick={() => setShowDetails(!showDetails)}>{literals.showDetails}</b>
        {
          showDetails && (
            <p className='mb-12'>
              {error?.error ? (
                `error: ${error?.error?.toString()}`
              ) : null}
              <hr />
              {error?.info ? (
                `info: ${JSON.stringify(error?.info)}`
              ) : null}
            </p>
          )
        }
      </div>
    );
  };

  const handleGoBack = () => {
    navigate(ROUTE_PATH.BASE);
  };

  return (
    <Layout rightMenu={false} className='text-center'>
      <AppShell>
        <div className='text-center pt-12'>
          <h2 className='mb-6'>{status}</h2>
          <h1 className='mb-4'>{title}</h1>
          {children}
          {renderBoundaryError()}
          <Button
            text={literals.back}
            onClick={handleGoBack}
            className='mt-12'
            type='primary'
          />
        </div>
      </AppShell>
    </Layout>
  );
};

ErrorLayout.propTypes = {
  title: PropTypes.string,
  status: PropTypes.string,
  error: PropTypes.object,
  literals: PropTypes.object.isRequired,
  children: PropTypes.node,
};

export default ErrorLayout;
